<template>
    <div
        :class="
            route.path === '/' ||
            route.path === `/${locale}` ||
            route.path == `/${locale}/` ||
            route.path.includes('/onboard') ||
            route.path.includes('/vote')
                ? 'bg-black/5'
                : 'bg-gray-50'
        "
        class="min-h-screen relative"
    >
        <NuxtLoadingIndicator color="#007fc0" :height="4" />
        <AuthErrorHandler />
        <PrimeToast group="default" />
        <PrimeToast group="loading">
            <template #message="slotProps">
                <div class="w-full" style="display: flex; align-items: start; gap: 10px">
                    <AppSpinner :size="2" />
                    <div class="w-fit">
                        <strong>{{ slotProps.message.summary }}</strong>
                        <p class="text-white/60 text-sm">{{ slotProps.message.detail }}</p>
                    </div>
                </div>
            </template>
        </PrimeToast>
        <AppCookie homepage v-model="showCookieBar" />
        <HeaderSidebar />
        <HeaderBOPanel @close="sidebarOpen = false" v-if="backoffice" class="hidden lg:flex" />

        <span
            v-if="backoffice"
            class="text-primary underline duration-1000 absolute transition-all hover:text-primary font-bold text-sm z-[50] right-8 bottom-4 cursor-pointer"
            @click="showCookieBar = true"
            >{{ $t('appcookie.privacy_settings') }}</span
        >
        <AppLayout
            @showConsent="showCookieBar = true"
            :navigation="navigation"
            v-if="$keycloak?.authenticated && backoffice"
        >
            <NuxtPage />
        </AppLayout>

        <NuxtPage @show-consent="showCookieBar = true" v-else></NuxtPage>
    </div>
</template>
<script setup lang="ts">
    import { useAuthStore } from '@whaleden/core/store/auth';
    import log from 'loglevel';

    const showCookieBar = ref(false);
    const { $keycloak } = useNuxtApp();
    const authStore = import.meta.client ? useAuthStore() : null;
    const { locale } = useI18n();
    const navigation = [{ name: 'Account', path: '/account', icon: ['far', 'user-shakespeare'] }];
    const route = useRoute();
    const router = useRouter();

    const backoffice = computed(() => {
        return (
            route.fullPath.startsWith('/account') ||
            route.fullPath.startsWith(`/${locale.value}/account`) ||
            route.fullPath.startsWith('/account/orders') ||
            route.fullPath.startsWith(`/${locale.value}/account/orders`) ||
            route.fullPath.startsWith('/transactions') ||
            route.fullPath.startsWith(`${locale.value}/transactions`)
        );
    });

    onMounted(() => {
        if (!$keycloak.authenticated) {
            return;
        }

        const token = $keycloak.token;

        const route = useRoute();
        const hasAuthMiddleware = route.meta.middleware && route.meta.middleware.includes('auth');

        if (token && authStore && !authStore.account?.fetched && !hasAuthMiddleware) {
            try {
                authStore.setIdentity(token);
            } catch (error) {
                log.error('Error setting identity:', error);
            }
        }
    });
</script>

<style lang="postcss">
    html {
        @apply scroll-smooth;
    }

    body {
        @apply h-full tracking-tight;
    }
</style>
